import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useRecoilValue } from 'recoil'
import { socialData as socialDataState } from '../store/dataStore'
import { SocialLinks } from '../styles/globalStyles'

import { Facebook, Twitter, Instagram, LinkedIn } from '../assets/svg/icons'

const Social = ({ isSideMenu, className }) => {
  const socialData = useRecoilValue(socialDataState)
  const socialIcons = {
    linkedin: LinkedIn,
    facebook: Facebook,
    twitter: Twitter,
    instagram: Instagram,
  }
  return (
    <SocialLinks
      initial={{
        opacity: 0,
      }}
      animate={{
        opacity: 1,
      }}
      exit={{
        opacity: 0,
        transition: {
          duration: 0.5,
          delay: 0,
          ease: 'linear',
        },
      }}
      transition={{
        duration: 1,
        delay: 1,
        ease: 'linear'
      }} 
      className={[isSideMenu && 'sidemenu', className && className]}>
      {Object.entries(socialData).map(([id, link]) => (
        <a
          className={id}
          key={id}
          href={link}
          target='_blank'
          rel='noopener noreferrer'>
          {React.createElement(socialIcons[id])}
        </a>
      ))}
    </SocialLinks>
  )
}

Social.propTypes = {
  isSideMenu: PropTypes.bool,
  className: PropTypes.string,
}

export default memo(Social)
